import { app } from '@/app';
import { MeasurementSystem } from '@/app/measurement-systems/model';
import { printCalculations as print } from '@/app/api/morgan-thermal/calculation/print';
import { createAndDownloadBlobFile } from '@/shared/helpers/blob';
import { File } from '@/app/api/morgan-thermal';

export const printCalculations = (calculationIds: number[]): Promise<File> => app.morganThermalAPI.fetch(print({
  isMetric: app.measurementSystems.currentSystem === MeasurementSystem.METRIC,
  calculationIds,
}))
  .then((file) => {
    createAndDownloadBlobFile(file.bytes, file.contentType, file.name);
    return file;
  });